import { render } from "./ListadoCerradosPendientes.vue?vue&type=template&id=2bf98ade"
import script from "./ListadoCerradosPendientes.vue?vue&type=script&lang=js"
export * from "./ListadoCerradosPendientes.vue?vue&type=script&lang=js"

import "./ListadoCerradosPendientes.vue?vue&type=style&index=0&id=2bf98ade&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__